import React from "react";
import PATH from "constants/path";
import { ChevronRight } from "assets/svg";
import ErrorDB from "components/ErrorDB";

const ListNews = ({ newsInit, isInLine }) => {
  return (
    <div className="list-news-more px-3 px-md-0">
      <div className="title my-2 my-md-3 text-center">ニュース</div>
      <div className="border-color-black border-radius-5 overflow-hidden">
        {isInLine && <ErrorDB/>}
        {!isInLine && newsInit?.map((item) => (
          <div key={item.id} className="item">
            <div className="date me-0 me-md-4">
              {item.posted}({item.day_of_week})
            </div>
            <a href={"/news/detail_new/" + item.id}>{item.title}</a>
          </div>
        ))}

        <div className="bg-item text-center text-grey py-1">
          <a href={PATH.NEWS} className="list-news-more-footer">
            すべて見る
            <span className="ms-2">
              <ChevronRight />
            </span>
          </a>
        </div>
      </div>
    </div>
  );
};

export default ListNews;
